export const imageManifest = [
  "/assets/aboutImg.png",
  "/assets/bgLayout.png",
  "/assets/boxEmpty.png",
  "/assets/chef1.jpeg",
  "/assets/chef1.png",
  "/assets/chef2.jpeg",
  "/assets/chef2.png",
  "/assets/chef3.jpeg",
  "/assets/chef3.png",
  "/assets/chef4.jpeg",
  "/assets/chef5.jpeg",
  "/assets/chef6.jpeg",
  "/assets/cup-illustration.png",
  "/assets/eventBottom.png",
  "/assets/eventTop.png",
  "/assets/footerimg1.png",
  "/assets/footerimg2.png",
  "/assets/footerimg3.png",
  "/assets/footerimg4.png",
  "/assets/footerimg5.png",
  "/assets/girl-drinking.png",
  "/assets/heroImg.png",
  "/assets/heroImg2.png",
  "/assets/heroImg3.png",
  "/assets/heroSecImg.png",
  "/assets/logo.svg",
  "/assets/panGraphics.png",
  "/assets/person.png",
  "/assets/person-white.png",
  "/assets/plate-illustration.png",
  "/assets/tailoredTaste.png",
  "/assets/tailoredTasteGreen.png",
  "/assets/tailoredTasteGreen.svg",
  "/assets/attt.png",
  "/assets/tailoredTasteWhite.png",
  "/assets/venueImg.png",
  "/assets/white-tailored-graphics.png",
  "/assets/whiteLogo.png",
];
